<template>
    <div id="app">
        <app-header></app-header>
        <!-- <side-nav></side-nav>
        <b-container :class="sideNav.active == true ? 'myBlur' : '' " fluid id="appContent"> -->
            <b-container id="appContent">
              <router-view/>
            </b-container>
        <!-- </b-container>
        <app-footer></app-footer> -->
    </div>

</template>
<script>
    import SideNav from "./components/sidenav/SideNav";
    import AppHeader from "./components/appHeader/AppHeader";
    import AppFooter from "./components/appFooter/AppFooter";
    import {notificationMixin} from "@/mixins/functions/notificationMixin";

    import {mapState} from "vuex";

    export default {
        components: {AppHeader, AppFooter, SideNav},
        mixins: [
            notificationMixin
        ],
        computed: {
            ...mapState(["sideNav"]),
        }
    }
</script>

<style lang="scss">
    @import './assets/scss/main.scss';
    @import './assets/scss/profile.scss';
    @import './assets/scss/sideNav.scss';
    @import './assets/scss/activity.scss';

    #app {
        /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
        font-family: "Myriad Pro", Myriad, "Liberation Sans", "Nimbus Sans L", "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-weight: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    #appContent {
        margin-top: 70px;
    }
</style>
